export default "__VITE_ASSET__b9T73Ojy__"